import { adminCopy } from "../copy/admin";
import { escapeHtml } from "../utils";

type SettingsOptions = {
  message: string;
  changePassword: (currentPassword: string, newPassword: string) => Promise<void>;
  changeEmail: (email: string, confirmEmail: string) => Promise<{ email: string }>;
  onMessage: (message: string) => void;
  reload: () => void;
};

export function changePasswordMarkup(message: string): string {
  return `
    <form id="consolePasswordForm" class="console-settings-form">
      <label>${adminCopy.settingsForm.currentPasswordLabel}<input name="currentPassword" type="password" autocomplete="current-password" required /></label>
      <label>${adminCopy.settingsForm.newPasswordLabel}<input name="newPassword" type="password" autocomplete="new-password" minlength="14" required /></label>
      <label>${adminCopy.settingsForm.confirmPasswordLabel}<input name="confirmPassword" type="password" autocomplete="new-password" minlength="14" required /></label>
      <button type="submit">${adminCopy.settingsForm.changePasswordAction}</button>
      <p class="status">${escapeHtml(message)}</p>
    </form>
  `;
}

export function changeEmailMarkup(message: string): string {
  return `
    <form id="consoleEmailForm" class="console-settings-form">
      <label>${adminCopy.settingsForm.newEmailLabel}<input name="email" type="email" autocomplete="email" required /></label>
      <label>${adminCopy.settingsForm.confirmEmailLabel}<input name="confirmEmail" type="email" autocomplete="email" required /></label>
      <button type="submit">${adminCopy.settingsForm.changeEmailAction}</button>
      <p class="status">${escapeHtml(message)}</p>
    </form>
  `;
}

export function bindSettingsForm(options: SettingsOptions): void {
  document.querySelector<HTMLFormElement>("#consolePasswordForm")?.addEventListener("submit", async (event) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget as HTMLFormElement);
    const newPassword = String(form.get("newPassword") || "");
    if (newPassword !== String(form.get("confirmPassword") || "")) {
      options.onMessage(adminCopy.settingsForm.passwordsMismatch);
      options.reload();
      return;
    }
    try {
      await options.changePassword(String(form.get("currentPassword") || ""), newPassword);
      options.onMessage(adminCopy.settingsForm.passwordChanged);
    } catch (error) {
      options.onMessage(error instanceof Error ? error.message : adminCopy.settingsForm.passwordFailure);
    }
    options.reload();
  });

  document.querySelector<HTMLFormElement>("#consoleEmailForm")?.addEventListener("submit", async (event) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget as HTMLFormElement);
    const email = String(form.get("email") || "");
    const confirmEmail = String(form.get("confirmEmail") || "");
    if (email.trim().toLowerCase() !== confirmEmail.trim().toLowerCase()) {
      options.onMessage(adminCopy.settingsForm.emailsMismatch);
      options.reload();
      return;
    }
    try {
      const payload = await options.changeEmail(email, confirmEmail);
      options.onMessage(adminCopy.settingsForm.emailChanged.replace("{email}", payload.email));
    } catch (error) {
      options.onMessage(error instanceof Error ? error.message : adminCopy.settingsForm.emailFailure);
    }
    options.reload();
  });
}
